import { render, staticRenderFns } from "./OrganizationLayout.vue?vue&type=template&id=5a0b2e4f&scoped=true"
import script from "./OrganizationLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationLayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationLayout.vue?vue&type=style&index=0&id=5a0b2e4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0b2e4f",
  null
  
)

export default component.exports